import React from 'react';
import DateRangeField from '../../../base/DateRangeField';
import { fieldNames } from '../../constants';
import { useFormWatch } from '../../../../../../helpers/formManager';
import { dateTime } from '../../../../shared/packages/dateTime';

const { createPickerSetting } = DateRangeField;

const pickerSettings = [
  createPickerSetting({
    name: fieldNames.fromDate,
    observableName: fieldNames.toDate,
    rules: { required: 'Укажите дату публикации' },
    label: 'Дата публикации у собственника',
    defaultValue: dateTime(),
    isFrom: true,
  }),
  createPickerSetting({
    name: fieldNames.toDate,
    observableName: fieldNames.fromDate,
    label: 'Дата окончания показа',
  }),
];

const PeriodField = () => {
  const availableToClient = useFormWatch({
    name: fieldNames.availableToClient,
    defaultValue: true,
  });

  if (!availableToClient) {
    return null;
  }

  return <DateRangeField pickerSettings={pickerSettings} />;
};

export default PeriodField;
